export function getFullYear(shortYear: string) {
  const currentYear = new Date().getFullYear()
  const currentCentury = Math.floor(currentYear / 100)
  const fullYear = currentCentury * 100 + parseInt(shortYear)

  return fullYear.toString()
}
